import { useRootElement } from '../../../../../../slatePlugins/common/hocs/current-element.store';
import cl from 'classnames';
import * as React from 'react';
import { TableBaseProps } from '../AdminView/types';

const useNodeInfoView = (tableElement, element) =>
  React.useMemo(() => {
    let columnNodeIndex = -1;
    const rowNodeIndex = tableElement?.children?.findIndex((row) =>
      row.children.some((cell, index) => {
        const isMatch = cell.id === element.id;
        if (isMatch) {
          columnNodeIndex = index;
        }
        return isMatch;
      })
    );

    return {
      hasBorder: tableElement?.border,
      hasColumnHeading: tableElement?.hasColumnHeading,
      hasRowHeading: tableElement?.hasRowHeading,
      rowIndex: rowNodeIndex,
      columnIndex: columnNodeIndex,
      isFirstRow: rowNodeIndex === 0,
      isLastRow: rowNodeIndex === tableElement?.children?.length - 1,
    };
  }, [tableElement, element]);

interface AdminTableCellProps extends TableBaseProps {}

export const TableTDReadOnly = (props: AdminTableCellProps) => {
  const { children, element } = props;
  const tableElement = useRootElement();
  const {
    isLastRow,
    isFirstRow,
    hasBorder,
    hasRowHeading,
    hasColumnHeading,
    rowIndex,
    columnIndex,
  } = useNodeInfoView(tableElement, element);
  if (element.hidden) return null;

  return (
    <td
      rowSpan={element.rowSpan}
      colSpan={element.colSpan}
      className={cl({
        'last-row': isLastRow,
        'first-row': isFirstRow,
        border: hasBorder,
        heading: (hasColumnHeading && columnIndex === 0) || (hasRowHeading && rowIndex === 0),
      })}
    >
      {children}
    </td>
  );
};
